import { get, patch, post, del } from 'utils/apiClient';

export async function add(params) {
  return post('documents', {
    body: params,
  });
}

export async function getAll(params) {
  return get('documents', { params });
}

export async function getAllForUserId(id, params) {
  return get(`users/${id}/documents`, { params });
}

export async function getImage(url) {
  return get(`images/${url}`, { responseType: 'blob' });
}

export async function getDocumentAccesses(id) {
  return get(`documents/${id}/accesses`);
}

export async function createDocumentAccess(id, body) {
  return post(`documents/${id}/accesses`, { body });
}

export async function updateDocumentAccess(id, body) {
  return patch(`documents-access/${id}`, { body });
}

export async function updateDocumentUserConsent(id, body) {
  return patch(`documents-user-consent/${id}`, { body });
}

// WUNA admin asking the document's owner for access.
export async function requestAccess(id) {
  return post(`documents/${id}/request-access`);
}

// piiFields: the personal details the verifier confirmed the document shows (at least one).
export async function verify(id, piiFields) {
  return post(`documents/${id}/verify`, { body: { piiFields } });
}

// approvalStatus: APPROVED | REJECTED — the user's answer to an on-behalf upload.
export async function respondToApproval(id, approvalStatus) {
  return patch(`documents/${id}/approval`, { body: { approvalStatus } });
}

export async function view(id) {
  return get('documents/' + id);
}

export async function deleteDocument(id, form) {
  return del('documents/' + id, {
    body: form,
  });
}

export async function getDocumentTicket(id) {
  return get(`documents/${id}/ticket`);
}

export async function download(id) {
  return get('document-download/' + id, { responseType: 'blob' });
}

export async function accessLog(id, params) {
  return get(`documents/${id}/documents-log`, { params });
}

export async function getExpiryStats({ type }) {
  return get(`document/expiry-stats`, { params: { type } });
}

export async function getCategoryStats() {
  return get(`document/category-stats`);
}

export async function getVerifiedCount() {
  return get(`document/verified-document-count`);
}

export async function uploadCsvFile(params) {
  return post('csv-upload', {
    body: params,
  });
}
